import * as React from 'react';

const AlertSvg = () => (
  <svg width={133} height={132} fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
    <path
      d="M39.221 92.179h37.593a27.884 27.884 0 0 0 27.72-30.883 34.705 34.705 0 0 0-37.4-30.827l-6.793.55A40.783 40.783 0 0 0 22.97 71.664v4.263A16.227 16.227 0 0 0 39.22 92.178Z"
      fill="var(--cds-color-blue-50)"
    />
    <path
      d="m66.499 19.883 52.717 92.235H13.781L66.5 19.883ZM66.5 52.828v30.745"
      stroke="var(--cds-color-neutral-primary)"
      strokeWidth={0.81}
      strokeLinejoin="round"
    />
    <path
      d="M66.498 98.945a4.4 4.4 0 1 0 0-8.8 4.4 4.4 0 0 0 0 8.8Z"
      stroke="var(--cds-color-neutral-primary)"
      strokeWidth={0.81}
      strokeLinejoin="round"
    />
  </svg>
);

export default AlertSvg;
